module.exports = __webpack_public_path__ + "static/media/MacLean2012Cover.4795c9fc.png";